import { css } from 'styled-components';
import { BLACK } from '../../../../constants/colors';

export default {
  wrapper: ({ isActive }) => css`
    display: flex;
    position: relative;
    align-self: center;
    width: 32px;
    height: 32px;
    transition: all ease-in-out 0.3s;

    ${isActive && css`
      transform: rotate(180deg);
    `};
  `,
  horizontalLine: css`
    position: absolute;
    width: 13px;
    height: 3px;
    top: 14px;
    left: 9px;
    background-color: ${BLACK};
    transition: all ease-in-out 0.3s;
  `,
  verticalLine: ({ isActive }) => css`
    position: absolute;
    width: 3px;
    height: 13px;
    top: 9px;
    left: 14px;
    background-color: ${BLACK};
    transition: all ease-in-out 0.3s;

    ${isActive && css`
      transform: rotate(-90deg);
    `};
  `
};
